export interface DrinkTransaction {
  accountDate: string;
  customerCount: number | null;
  source?: string | null;
  items: { category: string | null; menuName: string; quantity: number }[];
}

const soft = /ソフトドリンク|ノンアル|カフェ|コーヒー|珈琲|ジュース|コーラ|ジンジャーエール|烏龍茶|ウーロン茶|ジャスミン茶|紅茶|炭酸水|ラムネ/;
const alcohol = /アルコール|ビール|酎ハイ|チューハイ|サワー|ワイン|焼酎|日本酒|梅酒|果実酒|ウイスキー|ウィスキー|ハイボール|カクテル|ジン|ウォッカ|テキーラ/;

export const classifyDrink = (category: string | null, name: string): 'alcohol' | 'soft' | 'unknown' | null => {
  const cat = (category ?? '').normalize('NFKC');
  const menu = name.normalize('NFKC');
  // ノンアルコールはビール等のカテゴリでもソフトドリンクとして数える。
  if (/ノンアル/.test(menu)) return 'soft';
  if (soft.test(cat)) return 'soft';
  if (alcohol.test(cat)) return 'alcohol';
  // 食品やトッピングの名称に含まれる酒名・コーヒー等は数えない。
  if (!cat || /未設定|ドリンク|飲料|イベント|飲み放題|コース/.test(cat)) {
    if (soft.test(menu)) return 'soft';
    if (alcohol.test(menu)) return 'alcohol';
    if (/ドリンク|飲料|飲み放題/.test(cat + menu)) return 'unknown';
  }
  return null;
};

export const aggregateDrinks = (transactions: DrinkTransaction[]) => {
  let customers = 0;
  let alcoholCount = 0;
  let softCount = 0;
  let unknownCount = 0;
  let complete = transactions.length > 0;
  for (const tx of transactions) {
    if (tx.source === 'airregi-journal' || tx.customerCount == null || tx.customerCount <= 0) complete = false;
    customers += tx.customerCount ?? 0;
    for (const item of tx.items) {
      const kind = classifyDrink(item.category, item.menuName);
      if (kind === 'alcohol') alcoholCount += item.quantity;
      if (kind === 'soft') softCount += item.quantity;
      if (kind === 'unknown') unknownCount += item.quantity;
    }
  }
  const valid = complete && customers > 0;
  return {
    customers, alcoholCount, softCount, unknownCount,
    alcoholPerGuest: valid ? alcoholCount / customers : null,
    softPerGuest: valid ? softCount / customers : null,
  };
};
